(() => {
  if (customElements.get('dg-catalog')) return;
  customElements.define('dg-catalog',class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started=true;
      this.dataset.started='true';
      this.api=window.DuduGiftCatalog;
      this.events=new AbortController();
      this.media=matchMedia('(max-width:989px)');
      this.initialUrl=location.href;
      this.serverGrid=this.hasAttribute('data-server-rendered')?this.querySelector('[data-dg-server-grid]'):null;
      this.criteria=this.api.read(new URL(location.href));
      this.size=Number(this.dataset.pageSize)||16;
      this.strings=JSON.parse(this.querySelector('[data-dg-catalog-strings]').textContent);
      for (const key of Object.keys(this.strings)) if (typeof this.strings[key]==='string') this.strings[key]=this.api.decode(this.strings[key]);
      this.strings.labels=Object.fromEntries(Object.entries(this.strings.labels).map(([key,value])=>[key,this.api.decode(value)]));
      this.panel=this.querySelector('[data-dg-panel]');
      this.groups=this.querySelector('[data-dg-groups]');
      this.count=this.querySelector('[data-dg-count]');
      this.active=this.querySelector('[data-dg-active]');
      this.notice=this.querySelector('[data-dg-notice]');
      const signal={signal:this.events.signal};
      this.querySelector('[data-dg-open]').addEventListener('click',()=>this.openPanel(),signal);
      this.querySelectorAll('[data-dg-close],[data-dg-apply]').forEach(button=>button.addEventListener('click',()=>this.closePanel(),signal));
      this.querySelector('[data-dg-clear]').addEventListener('click',()=>this.clear(),signal);
      this.querySelector('[data-dg-sort]').addEventListener('change',event=>{
        const url=new URL(location.href);url.searchParams.set('sort_by',event.target.value);
        this.criteria.page=1;history.pushState({},'',this.api.write(url,this.criteria));this.start();
      },signal);
      this.groups.addEventListener('change',event=>{
        const input=event.target;
        if (input.type!=='checkbox') return;
        const key=input.dataset.key;
        this.criteria[key]=[...this.groups.querySelectorAll('input[type=checkbox]')].filter(item=>item.dataset.key===key&&item.checked).map(item=>item.value);
        this.change();
      },signal);
      this.groups.addEventListener('input',event=>{
        if (!event.target.matches('[data-option-search]')) return;
        const term=event.target.value.trim().toLocaleLowerCase();
        event.target.closest('details').querySelectorAll('[data-option-row]').forEach(row=>{row.hidden=!row.dataset.label.toLocaleLowerCase().includes(term);});
      },signal);
      this.addEventListener('keydown',event=>{
        if (event.key==='Escape' && this.dataset.mobileOpen==='true') this.closePanel();
        if (event.key==='Tab' && this.dataset.mobileOpen==='true') {
          const focusable=[...this.panel.querySelectorAll('button,input,summary')].filter(el=>!el.disabled&&el.getClientRects().length);
          if (!focusable.length) return;
          if (event.shiftKey&&event.target===focusable[0]) {event.preventDefault();focusable.at(-1).focus();}
          else if (!event.shiftKey&&event.target===focusable.at(-1)) {event.preventDefault();focusable[0].focus();}
        }
      },signal);
      this.media.addEventListener('change',()=>this.closePanel(false),signal);
      window.addEventListener('popstate',()=>{this.criteria=this.api.read(new URL(location.href));this.start();},signal);
      this.start();
    }
    disconnectedCallback() {this.events?.abort();this.closePanel(false);this.started=false;}
    element(tag,className,text) {
      const element=document.createElement(tag);if (className) element.className=className;if (text!=null) element.textContent=text;return element;
    }
    canKeepServerGrid() {
      return Boolean(this.serverGrid?.isConnected&&this.serverGrid.hasAttribute('data-dg-server-grid')&&!this.hasFilters()&&location.href===this.initialUrl);
    }
    async start() {
      const version=this.version=(this.version||0)+1;
      this.querySelector('[data-dg-tools]').hidden=false;
      if (!this.canKeepServerGrid()) this.count.textContent=this.strings.loading;
      this.notice.hidden=true;
      if (this.hasFilters()) this.dataset.filteringPending='true';
      try {
        const products=await this.api.load(location.href);
        if (version!==this.version||!this.isConnected) return;
        this.products=products;
        this.panel.hidden=false;
        this.dataset.enhanced='true';
        const container=this.querySelector('#ProductGridContainer');
        if (!container) throw new Error('Missing product grid');
        if (!this.grid||!this.grid.isConnected) {
          this.grid=this.serverGrid?.isConnected?this.serverGrid:this.element('ul','grid product-grid grid--2-col-tablet-down grid--4-col-desktop');
          this.grid.id='product-grid';
          this.empty=this.element('div','dg-catalog-empty');
          this.empty.append(this.element('p','',this.strings.empty));
          const clear=this.element('button','dg-button',this.strings.clear);clear.type='button';clear.addEventListener('click',()=>this.clear());this.empty.append(clear);
          this.pagination=this.querySelector('[data-dg-server-pagination]')||this.element('nav','dg-catalog-pagination');this.pagination.setAttribute('aria-label',this.strings.pagination);
          if (this.grid===this.serverGrid) {this.empty.hidden=true;this.grid.after(this.empty);}
          else container.replaceChildren(this.grid,this.empty,this.pagination);
        }
        this.buildGroups();this.render(this.canKeepServerGrid());delete this.dataset.filteringPending;delete document.documentElement.dataset.dgCatalogFiltered;
      } catch {
        if (version!==this.version) return;
        if (!this.canKeepServerGrid()) this.count.textContent='';
        const filterLoading=this.querySelector('.dg-catalog-filter-loading');if(filterLoading) filterLoading.textContent=this.strings.filter_error;
        this.notice.replaceChildren(this.element('span','',this.canKeepServerGrid()?this.strings.filter_error:this.strings.error));
        const retry=this.element('button','',this.strings.retry);retry.type='button';retry.addEventListener('click',()=>this.start());this.notice.append(retry);this.notice.hidden=false;
      }
    }
    hasFilters() {return Object.keys(this.api.names).some(key=>this.criteria[key]?.length)||this.criteria.min!==''||this.criteria.max!=='';}
    buildGroups() {
      this.groups.replaceChildren();
      this.optionInputs=[];
      for (const key of ['category','type','price','recipients','interests','occasions','colors','personalized','stock']) {
        let values=[];
        if (!['price','personalized','stock'].includes(key)) values=[...new Set(this.products.flatMap(product=>Array.isArray(product[key])?product[key]:product[key]?[product[key]]:[]))].sort((a,b)=>a.localeCompare(b));
        if (key==='personalized'&&!this.products.some(product=>product.personalized)) continue;
        if (!['price','personalized','stock'].includes(key)&&!values.length) continue;
        const details=this.element('details','dg-catalog-group');details.dataset.group=key;details.open=key==='category';
        const summary=this.element('summary','',this.strings.labels[key]);summary.append(this.element('span','dg-catalog-chevron','⌄'));details.append(summary);
        const content=this.element('div','dg-catalog-group-content');
        if (key==='price') {this.priceForm(content);details.append(content);this.groups.append(details);continue;}
        if (values.length>8) {
          const search=this.element('input','dg-catalog-option-search');search.type='search';search.placeholder=this.strings.search;search.setAttribute('aria-label',this.strings.search+' '+this.strings.labels[key]);search.dataset.optionSearch=key;content.append(search);
        }
        const list=this.element('div','dg-catalog-option-list');
        if (key==='stock') values=['1'];
        if (key==='personalized') values=['true'];
        for (const value of values) {
          const label=this.element('label','dg-catalog-option');label.dataset.optionRow='';label.dataset.label=value;
          const input=this.element('input');input.type='checkbox';input.value=value;input.dataset.key=key;input.checked=this.criteria[key]?.includes(value)||false;
          const text=this.element('span','',key==='stock'?this.strings.labels.stock:key==='personalized'?this.strings.labels.personalized:value);
          if (key==='colors') text.setAttribute('data-filter-color',value);
          const count=this.element('span','dg-catalog-option-number');label.append(input,text,count);list.append(label);this.optionInputs.push({input,count,key,value});
        }
        content.append(list);details.append(content);this.groups.append(details);
      }
    }
    priceForm(content) {
      const form=this.element('form','dg-catalog-price');
      const row=this.element('div','dg-catalog-price-row');
      for (const key of ['min','max']) {
        const label=this.element('label','',this.strings[key]);const input=this.element('input');input.type='number';input.min='0';input.step='0.01';input.inputMode='decimal';input.value=this.criteria[key];input.dataset.price=key;input.setAttribute('aria-label',this.strings[key]);label.append(input);row.append(label);
      }
      const button=this.element('button','',this.strings.apply);button.type='submit';form.append(row,button);
      form.addEventListener('submit',event=>{
        event.preventDefault();const min=form.querySelector('[data-price=min]'),max=form.querySelector('[data-price=max]');max.setCustomValidity('');
        if (min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value)) max.setCustomValidity(this.strings.price_error);
        if (!form.reportValidity()) return;
        this.criteria.min=min.value;this.criteria.max=max.value;this.change();
      });content.append(form);
    }
    change() {this.criteria.page=1;history.pushState({},'',this.api.write(location.href,this.criteria));this.render();}
    clear() {this.criteria=this.api.read(this.api.baseUrl(location.href));history.pushState({},'',this.api.write(location.href,this.criteria));if(!this.products){this.start();return;}this.buildGroups();this.render();}
    render(keepServerGrid=false) {
      const products=this.products.filter(product=>this.api.matches(product,this.criteria));
      this.count.textContent=products.length===1?this.strings.count_one:this.strings.count.replace('[count]',String(products.length));
      this.querySelector('[data-dg-apply]').textContent=products.length===1?this.strings.show_one:this.strings.show.replace('[count]',String(products.length));
      const choices=Object.keys(this.api.names).reduce((total,key)=>total+(this.criteria[key]?.length||0),0)+(this.criteria.min!==''||this.criteria.max!==''?1:0);
      this.querySelector('[data-dg-filter-count]').textContent=choices?'('+choices+')':'';
      this.active.replaceChildren();
      for (const key of Object.keys(this.api.names)) for (const value of this.criteria[key]||[]) this.chip(key,value,(key==='stock'||key==='personalized'?this.strings.labels[key]:value));
      if (this.criteria.min!==''||this.criteria.max!=='') this.chip('price','',this.strings.labels.price+': '+(this.criteria.min||'0')+' – '+(this.criteria.max||'∞'));
      this.active.hidden=!this.active.children.length;
      for (const {input,count,key,value} of this.optionInputs) {
        const criteria={...this.criteria,[key]:[value]};
        const amount=this.products.filter(product=>this.api.matches(product,criteria)).length;
        input.checked=this.criteria[key]?.includes(value)||false;input.disabled=!amount&&!input.checked;count.textContent=String(amount);
      }
      if(keepServerGrid)return;
      this.grid.removeAttribute('data-dg-server-grid');
      this.pagination.hidden=false;
      const pages=Math.ceil(products.length/this.size);this.criteria.page=Math.min(this.criteria.page,Math.max(1,pages));
      const visible=products.slice((this.criteria.page-1)*this.size,this.criteria.page*this.size);
      this.grid.replaceChildren(...visible.map(product=>this.card(product)));
      this.empty.hidden=products.length>0;this.grid.hidden=!products.length;
      this.pagination.replaceChildren();
      if (pages>1) {
        const addPage=(page,text,label,jump)=>{
          const disabled=Boolean(jump)&&page===this.criteria.page;
          const control=this.element(disabled?'span':'a',jump?'dg-catalog-page-jump':'',text);
          control.setAttribute('aria-label',label);
          if (jump) {control.dataset.dgPageJump=jump;control.title=label;}
          if (disabled) {control.setAttribute('role','link');control.setAttribute('aria-disabled','true');}
          else {
            control.href=this.api.write(location.href,{...this.criteria,page}).href;
            if (!jump&&page===this.criteria.page) control.setAttribute('aria-current','page');
            control.addEventListener('click',event=>{
              if (event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
              event.preventDefault();this.criteria.page=page;history.pushState({},'',control.href);this.render();this.querySelector('[data-dg-tools]').scrollIntoView({block:'start',behavior:'instant'});
            });
          }
          this.pagination.append(control);
        };
        addPage(1,'«',this.strings.first,'first');
        for (let page=1;page<=pages;page++) {
          if (pages>9&&page!==1&&page!==pages&&Math.abs(page-this.criteria.page)>2) {if (page===2||page===pages-1) this.pagination.append(this.element('span','','…'));continue;}
          addPage(page,String(page),this.strings.page.replace('[number]',String(page)));
        }
        addPage(pages,'»',this.strings.last,'last');
      }
    }
    chip(key,value,text) {
      const button=this.element('button','dg-catalog-chip',text+' ×');button.type='button';
      button.addEventListener('click',()=>{if (key==='price') {this.criteria.min='';this.criteria.max='';this.groups.querySelectorAll('[data-price]').forEach(input=>{input.value='';});}else this.criteria[key]=this.criteria[key].filter(item=>item!==value);this.change();});this.active.append(button);
    }
    card(product) {
      const variants=product.variants.filter(variant=>this.api.variantMatches(product,variant,this.criteria));
      const cheapest=variants.reduce((best,variant)=>!best||variant.price<best.price?variant:best,null);
      const prices=variants.map(variant=>variant.price);const price=cheapest?cheapest.price:product.price;
      const filteredVariant=this.criteria.colors.length||this.criteria.min!==''||this.criteria.max!==''||this.criteria.stock.length;
      const productUrl=new URL(product.url,location.origin);
      if (filteredVariant&&cheapest) productUrl.searchParams.set('variant',String(cheapest.id));
      const url=productUrl.href;
      const li=this.element('li','grid__item');const article=this.element('article','dg-catalog-card');article.dataset.dgProductId=String(product.id);article.dataset.dgRenderOrigin='client';const link=this.element('a','dg-catalog-card-image');link.href=url;link.setAttribute('aria-label',product.title);
      if (product.image) {
        const image=this.element('img');image.src=filteredVariant&&cheapest?.image?cheapest.image:product.image.src;image.alt=product.image.alt||product.title;image.width=product.image.width||600;image.height=product.image.height||600;image.loading='lazy';image.decoding='async';link.append(image);
      }
      if (!product.available) link.append(this.element('span','dg-catalog-sold',this.strings.sold));
      const heading=this.element('h3');const title=this.element('a','',product.title);title.href=url;title.title=product.title;heading.append(title);
      const currency=product.currency||'USD';const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency}).format(price/100);
      const priceLine=this.element('p','dg-catalog-card-price');
      if(prices.length&&Math.max(...prices)>price) priceLine.append(this.element('span','dg-card-price-prefix',this.strings.from+' '));
      priceLine.append(this.element('span','dg-card-price-value',money),this.element('span','dg-card-price-currency',' '+currency));
      const actions=this.element('dg-gift-actions');
      const data=this.element('script');data.type='application/json';data.dataset.dgCardProduct='';data.textContent=JSON.stringify({...product,variants});actions.append(data);
      article.append(link,heading,priceLine,actions);li.append(article);return li;
    }
    openPanel() {
      this.dataset.mobileOpen='true';this.panel.setAttribute('role','dialog');this.panel.setAttribute('aria-modal','true');this.querySelector('[data-dg-open]').setAttribute('aria-expanded','true');this.querySelector('.dg-catalog-scrim').hidden=false;this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.panel.querySelector('.dg-catalog-close').focus();
    }
    closePanel(focus=true) {
      if (!this.panel||this.dataset.mobileOpen!=='true') return;
      delete this.dataset.mobileOpen;this.panel.removeAttribute('role');this.panel.removeAttribute('aria-modal');this.querySelector('[data-dg-open]').setAttribute('aria-expanded','false');this.querySelector('.dg-catalog-scrim').hidden=true;document.body.style.overflow=this.previousOverflow||'';if (focus) this.querySelector('[data-dg-open]').focus();
    }
  });
})();
